@if (!isLoading) {
  <div>
    <div [class]="isPage ? 'container-fluid pt-4 pb-4' : ''">
      <div class="tw-mb-5 tw-items-start" [ngClass]="isInvitedToInvest ? '' : ''">
        <div class="tw-flex tw-flex-col tw-justify-between tw-gap-3 lg:tw-flex-row">
          <div
            class="text-primary text-underline cursor-pointer"
            [routerLink]="'/my-campaign'"
          ></div>
          <h4
            class="font-weight-extrabold text-black"
            [ngClass]="!isPage ? 'md:!tw-text-left' : ''"
          >
            {{ campaign?.name }} {{ 'campaign.investors' | translate }}
          </h4>
          @if (campaign?.isCreator) {
            <div class="" [class.md:tw-col-span-2]="!isPage">
              <div class="tw-flex tw-items-center tw-justify-between">
                <div>
                  <button
                    type="button"
                    class="btn btn-primary-border"
                    (click)="getCampaignInvestorList(true)"
                  >
                    {{ 'common.export' | translate }}
                  </button>
                </div>
                <div class="d-xl-none tw-flex tw-items-center tw-justify-between">
                  <div class="d-inline-block" ngbDropdown #sortDropdown="ngbDropdown">
                    <button
                      class="btn custom-btn-link p-0 text-decoration-none text-uppercase font-weight-bold"
                      type="button"
                      ngbDropdownToggle
                      id="sortingDropdown"
                    >
                      <img
                        height="26px"
                        width="26px"
                        src="../../../assets/img/icons/svgs/sort.svg"
                        class="cursor-pointer"
                        alt="Sort"
                      />
                    </button>
                    <div
                      ngbDropdownMenu
                      [attr.aria-labelledby]="'sortingDropdown'"
                      class="p-3 custom-dropdown-menu-block"
                    >
                      <div class="custom-dropdown-menu-content">
                        <div
                          class="tw-flex tw-items-center tw-justify-between"
                          (click)="sortInvestors('createdAt')"
                        >
                          <div>Date Invested</div>
                          <div>
                            @switch (checkSortStatus('createdAt')) {
                              @case (1) {
                                <div>
                                  <img
                                    height="16px"
                                    width="16px"
                                    src="../../../assets/img/icons/svgs/sortup.svg"
                                    class="cursor-pointer"
                                    alt="Sort"
                                  />
                                </div>
                              }
                              @case (2) {
                                <div>
                                  <img
                                    height="16px"
                                    width="16px"
                                    src="../../../assets/img/icons/svgs/sortdown.svg"
                                    class="cursor-pointer"
                                    alt="Sort"
                                  />
                                </div>
                              }
                              @default {
                                <div>
                                  <img
                                    height="16px"
                                    width="16px"
                                    src="../../../assets/img/icons/svgs/sort.svg"
                                    class="cursor-pointer"
                                    alt="Sort"
                                  />
                                </div>
                              }
                            }
                          </div>
                        </div>
                        <div
                          class="tw-flex tw-items-center tw-justify-between"
                          (click)="sortInvestors('pledgedAmount')"
                        >
                          <div>Total Invested</div>
                          <div>
                            @switch (checkSortStatus('pledgedAmount')) {
                              @case (1) {
                                <div>
                                  <img
                                    height="16px"
                                    width="16px"
                                    src="../../../assets/img/icons/svgs/sortup.svg"
                                    class="cursor-pointer"
                                    alt="Sort"
                                  />
                                </div>
                              }
                              @case (2) {
                                <div>
                                  <img
                                    height="16px"
                                    width="16px"
                                    src="../../../assets/img/icons/svgs/sortdown.svg"
                                    class="cursor-pointer"
                                    alt="Sort"
                                  />
                                </div>
                              }
                              @default {
                                <div>
                                  <img
                                    height="16px"
                                    width="16px"
                                    src="../../../assets/img/icons/svgs/sort.svg"
                                    class="cursor-pointer"
                                    alt="Sort"
                                  />
                                </div>
                              }
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (IsStatusFilterEnable()) {
                    <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
                      <button
                        class="btn custom-btn-link p-0 text-decoration-none text-uppercase font-weight-bold"
                        type="button"
                        ngbDropdownToggle
                        id="statusFilterDropdown"
                      >
                        <img
                          height="26px"
                          width="26px"
                          src="../../../assets/img/icons/svgs/filter.svg"
                          class="cursor-pointer"
                          alt="Sort"
                        />
                      </button>
                      <div
                        ngbDropdownMenu
                        [attr.aria-labelledby]="'statusFilterDropdown'"
                        class="p-3 custom-dropdown-menu-block"
                      >
                        <div class="custom-dropdown-menu-content">
                          <span class="tw-font-bold">
                            {{ 'campaign.PaymentStatus' | translate }}
                          </span>
                          <div class="form-check">
                            <input
                              class="form-check-input checkbox-color"
                              type="checkbox"
                              id="statusAll"
                              [checked]="isAllStatusesSelected()"
                              (change)="toggleAllStatuses($event)"
                            />
                            <label class="form-check-label" for="statusAll">
                              {{ 'campaign.All' | translate }}
                            </label>
                          </div>
                          <div class="custom-border-top"></div>
                          @for (status of investmentStatusEntries; track status) {
                            <div>
                              <div class="form-check">
                                <input
                                  class="form-check-input checkbox-color"
                                  type="checkbox"
                                  [id]="'status' + status.key"
                                  [checked]="isStatusSelected(status.key)"
                                  (change)="toggleStatus(status.key, $event)"
                                />
                                <label class="form-check-label" [for]="'status' + status.key">
                                  {{ 'investment.' + status.value | translate }}
                                </label>
                              </div>
                            </div>
                          }
                        </div>
                        @if (hasReferralCodes) {
                          <div class="custom-dropdown-menu-content" style="margin-top: 16px">
                            <span class="tw-font-bold">
                              {{ 'campaign.Referral' | translate }}
                            </span>
                            <div class="form-check">
                              <input
                                class="form-check-input checkbox-color"
                                type="checkbox"
                                id="referralCodeAll"
                                [checked]="isAllReferralCodeSelected()"
                                (change)="toggleAllReferralCode($event)"
                              />
                              <label class="form-check-label" for="referralCodeAll">
                                {{ 'referralCode.All' | translate }}
                              </label>
                            </div>
                            <div class="custom-border-top"></div>
                            @for (referralCode of referralCodeEntries; track referralCode) {
                              <div>
                                <div class="form-check">
                                  <input
                                    class="form-check-input checkbox-color"
                                    type="checkbox"
                                    [id]="'referralCode' + referralCode.key"
                                    [checked]="isReferralCodeSelected(referralCode.key)"
                                    (change)="toggleReferralCode(referralCode.key, $event)"
                                  />
                                  <label
                                    class="form-check-label"
                                    [for]="'referralCode' + referralCode.key"
                                  >
                                    {{ referralCode.value | translate }}
                                  </label>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <div class="custom-dropdown-menu-content" style="margin-top: 16px">
                          <div class="tw-flex tw-justify-end">
                            <button class="btn btn-sm clear-btn" (click)="resetAllFilters($event)">
                              <div class="filter-btn-text">Clear</div>
                            </button>
                            <button class="btn btn-sm apply-btn" (click)="applyAllFilters()">
                              <div class="filter-btn-text">Apply</div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (campaign?.isCreator && campaign) {
          <div class="sort-label d-xl-none">
            <div class="sort-title">{{ 'investment.' + sortby | translate }}</div>
            <div class="sort-subtitle">{{ 'investment.' + sortdirection | translate }}</div>
          </div>
        }
        @if (isInvitedToInvest) {
          <!-- Non-Creator investor list header -->
          @if (!campaign?.isCreator && campaign) {
            <div class="row d-none d-lg-flex investor-list">
              <div
                class="col-sm-4 user-info text-uppercase font-weight-bold font-size-smaller"
                [class.col-lg-8]="!campaign?.isCreator"
              >
                {{ 'campaign.investors' | translate }}
              </div>
              <div
                class="col-sm-4 investor-info text-uppercase font-weight-bold font-size-smaller"
                [class.col-lg-4]="!campaign?.isCreator"
                [class.lg:!tw-text-right]="!campaign?.isCreator"
              >
                {{ 'portfolio.totalInvested' | translate }}
              </div>
            </div>
          }
          <!-- Creator specific header row (MOVED HERE and condition updated) -->
          @if (campaign?.isCreator && campaign) {
            <div class="row d-none d-xl-flex investor-list custom-fontsize-07">
              <div class="col-xl-2 investor-info">
                <div class="d-inline-block" ngbDropdown #referralCodeDropdown="ngbDropdown">
                  <button
                    class="btn custom-btn-link p-0 text-decoration-none text-uppercase font-weight-bold"
                    type="button"
                    ngbDropdownToggle
                    id="referralCodeFilterDropdown"
                  >
                    {{ 'campaign.investors' | translate }}
                    <i class="fa fa-filter ml-1"></i>
                  </button>
                  <div
                    ngbDropdownMenu
                    [attr.aria-labelledby]="'referralCodeFilterDropdown'"
                    class="p-3 custom-dropdown-menu-block"
                  >
                    <div class="custom-dropdown-menu-content">
                      <div class="form-check">
                        <input
                          class="form-check-input checkbox-color"
                          type="checkbox"
                          id="referralCodeAll"
                          [checked]="isAllReferralCodeSelected()"
                          (change)="toggleAllReferralCode($event)"
                        />
                        <label class="form-check-label" for="referralCodeAll">
                          {{ 'referralCode.All' | translate }}
                        </label>
                      </div>
                      <div class="custom-border-top"></div>
                      @for (referralCode of referralCodeEntries; track referralCode) {
                        <div>
                          <div class="form-check">
                            <input
                              class="form-check-input checkbox-color"
                              type="checkbox"
                              [id]="'referralCode' + referralCode.key"
                              [checked]="isReferralCodeSelected(referralCode.key)"
                              (change)="toggleReferralCode(referralCode.key, $event)"
                            />
                            <label
                              class="form-check-label"
                              [for]="'referralCode' + referralCode.key"
                            >
                              {{ referralCode.value | translate }}
                            </label>
                          </div>
                        </div>
                      }
                      <div class="tw-flex tw-justify-end">
                        <button class="btn btn-sm clear-btn" (click)="resetReferralCode($event)">
                          <div class="filter-btn-text">Clear</div>
                        </button>
                        <button class="btn btn-sm apply-btn" (click)="filterByReferralCode()">
                          <div class="filter-btn-text">Apply</div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-2 investor-info text-uppercase font-weight-bold"
                (click)="sortInvestors('pledgedAmount')"
              >
                {{ 'portfolio.totalInvestedRM' | translate }}
                <i
                  class="fa fa-sort ml-1"
                  [class.fa-sort-up]="
                    params.sortBy === 'pledgedAmount' && params.sortDirection === SortDirection.Asc
                  "
                  [class.fa-sort-down]="
                    params.sortBy === 'pledgedAmount' && params.sortDirection === SortDirection.Desc
                  "
                ></i>
              </div>
              <div
                class="col-xl-2 investor-info text-uppercase font-weight-bold"
                (click)="sortInvestors('createdAt')"
              >
                {{ 'portfolio.dateInvested' | translate }}
                <i
                  class="fa fa-sort ml-1"
                  [class.fa-sort-up]="
                    params.sortBy === 'createdAt' && params.sortDirection === SortDirection.Asc
                  "
                  [class.fa-sort-down]="
                    params.sortBy === 'createdAt' && params.sortDirection === SortDirection.Desc
                  "
                ></i>
              </div>
              <div class="col-xl-2 investor-info">
                @if (!isMultiShareType) {
                  <div class="text-uppercase font-weight-bold">
                    {{ 'portfolio.shareType' | translate }}
                  </div>
                }
                @if (isMultiShareType) {
                  <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
                    <button
                      class="btn custom-btn-link p-0 text-decoration-none text-uppercase font-weight-bold"
                      type="button"
                      ngbDropdownToggle
                      id="sharetypeFilterDropdown"
                    >
                      {{ 'portfolio.shareType' | translate }}
                      <i class="fa fa-filter ml-1"></i>
                    </button>
                    <div
                      ngbDropdownMenu
                      [attr.aria-labelledby]="'sharetypeFilterDropdown'"
                      class="p-3 custom-dropdown-menu-block"
                    >
                      <div class="custom-dropdown-menu-content">
                        <div class="form-check">
                          <input
                            class="form-check-input checkbox-color"
                            type="checkbox"
                            id="sharetypeAll"
                            [checked]="isAllShareType()"
                            (change)="toggleAllShareType($event)"
                          />
                          <label class="form-check-label" for="sharetypeAll">
                            {{ 'campaign.All' | translate }}
                          </label>
                        </div>
                        <div class="custom-border-top"></div>
                        @for (sharetype of ShareTypeEntries; track sharetype) {
                          <div>
                            <div class="form-check">
                              <input
                                class="form-check-input checkbox-color"
                                type="checkbox"
                                [id]="'sharetype' + sharetype.key"
                                [checked]="isShareTypeSelected(sharetype.key)"
                                (change)="toggleShareType(sharetype.key, $event)"
                              />
                              <label
                                class="form-check-label text-uppercase"
                                [for]="'sharetype' + sharetype.key"
                              >
                                {{ sharetype.value }}
                              </label>
                            </div>
                          </div>
                        }
                        <div class="tw-flex tw-justify-end">
                          <button
                            class="clear-btn btn-sm tw-text-sm"
                            (click)="resetShareType($event)"
                          >
                            <div class="tw-text-xxs">Clear</div>
                          </button>
                          <button class="apply-btn btn-sm tw-text-sm" (click)="filterByShareType()">
                            <div class="tw-text-xxs">Apply</div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="col-xl-2 investor-info text-uppercase font-weight-bold">
                {{ 'portfolio.totalSharedQuantity' | translate }}
              </div>
              <div class="col-xl-2 investor-info">
                @if (!IsStatusFilterEnable()) {
                  <div class="text-uppercase font-weight-bold">
                    {{ 'common.status' | translate }}
                  </div>
                }
                @if (IsStatusFilterEnable()) {
                  <div class="d-inline-block" ngbDropdown #statusDropdown="ngbDropdown">
                    <button
                      class="btn custom-btn-link p-0 text-decoration-none text-uppercase font-weight-bold"
                      type="button"
                      ngbDropdownToggle
                      id="statusFilterDropdown"
                    >
                      {{ 'common.status' | translate }}
                      <i class="fa fa-filter ml-1"></i>
                    </button>
                    <div
                      ngbDropdownMenu
                      [attr.aria-labelledby]="'statusFilterDropdown'"
                      class="p-3 custom-dropdown-menu-block"
                    >
                      <div class="custom-dropdown-menu-content">
                        <div class="form-check">
                          <input
                            class="form-check-input checkbox-color"
                            type="checkbox"
                            id="statusAll"
                            [checked]="isAllStatusesSelected()"
                            (change)="toggleAllStatuses($event)"
                          />
                          <label class="form-check-label" for="statusAll">
                            {{ 'campaign.All' | translate }}
                          </label>
                        </div>
                        <div class="custom-border-top"></div>
                        @for (status of investmentStatusEntries; track status) {
                          <div>
                            <div class="form-check">
                              <input
                                class="form-check-input checkbox-color"
                                type="checkbox"
                                [id]="'status' + status.key"
                                [checked]="isStatusSelected(status.key)"
                                (change)="toggleStatus(status.key, $event)"
                              />
                              <label class="form-check-label" [for]="'status' + status.key">
                                {{ 'investment.' + status.value | translate }}
                              </label>
                            </div>
                          </div>
                        }
                        <div class="tw-flex tw-justify-end">
                          <button class="btn btn-sm clear-btn" (click)="resetstatus($event)">
                            <div class="filter-btn-text">Clear</div>
                          </button>
                          <button class="btn btn-sm apply-btn" (click)="filterByStatus()">
                            <div class="filter-btn-text">Apply</div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <!-- This div now only wraps the dynamic list part -->
          @if (!isLoading) {
            <div>
              @for (investment of investments; track investment) {
                <div>
                  @if (!campaign?.isCreator) {
                    <div class="row investor-panel">
                      <div
                        class="col-sm-4 user-info d-flex"
                        [class.col-lg-8]="!campaign?.isCreator"
                      >
                        <img
                          [alt]="
                            investment.isAnonymous
                              ? ('investment.anonymous' | translate)
                              : formatInvestorName(investment.user?.fullName) ||
                                ('investment.anonymous' | translate)
                          "
                          [src]="investment.user?.photoAttachmentUrl || defaultProfileImage"
                          class="investor-image"
                        />
                        <span class="text-black font-size-regular align-middle">
                          {{
                            investment.isAnonymous
                              ? ('investment.anonymous' | translate)
                              : formatInvestorName(investment.user?.fullName) ||
                                ('investment.anonymous' | translate)
                          }}
                        </span>
                      </div>
                      <div
                        class="col-sm-4 investor-info"
                        [class.lg:!tw-text-right]="!campaign?.isCreator"
                      >
                        <div class="text-uppercase font-weight-bold font-size-smaller d-xl-none">
                          {{ 'portfolio.totalInvested' | translate }}
                        </div>
                        <div class="text-primary font-weight-bold font-size-regular">
                          {{ investment.pledgedAmount | numberSuffix }}
                        </div>
                        <div class="text-gray font-size-smaller">
                          {{ investment.createdAt | amDateFormat: 'D MMM YYYY' }}
                        </div>
                      </div>
                    </div>
                  }
                  @if (campaign?.isCreator) {
                    <div class="row investor-panel investor-divider custom-fontsize-07">
                      <div class="col-xl-2 user-info d-flex invester-order">
                        <img
                          [alt]="
                            formatInvestorName(investment.user?.fullName) ||
                            ('investment.anonymous' | translate)
                          "
                          [src]="investment.user?.photoAttachmentUrl || defaultProfileImage"
                          class="investor-image"
                        />
                        <div class="d-flex flex-column">
                          <span class="text-black invester-title">
                            {{
                              formatInvestorName(investment.user?.fullName) ||
                                ('investment.anonymous' | translate)
                            }}
                          </span>
                          @if (investment.referralCode && isMobile) {
                            <span
                              class="d-inline-flex align-items-center refercode"
                              (click)="copyReferralCode(investment.referralCode)"
                            >
                              <img
                                src="/assets/img/icons/svgs/referralcode.svg"
                                style="width: 10px; height: 10px"
                                alt="tag"
                              />
                              {{ investment.referralCode }}
                            </span>
                          }
                          @if (investment.referralCode && !isMobile) {
                            <span
                              class="refercode-clickable d-inline-flex align-items-center refercode"
                              [class.copied]="copiedCode === investment.referralCode"
                              matTooltip="{{ investment.referralCode }}"
                              matTooltipPosition="above"
                              matTooltipClass="custom-tooltip "
                              (click)="copyReferralCode(investment.referralCode)"
                            >
                              <img
                                src="/assets/img/icons/svgs/referralcode.svg"
                                class="icon"
                                alt="tag"
                              />
                              <span class="truncate-text">{{ investment.referralCode }}</span>
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-xl-2 investor-info total-order">
                        <div
                          class="text-uppercase xl:font-weight-bold font-size-smaller d-xl-none invester-title"
                        >
                          {{ 'portfolio.totalInvested' | translate }}
                        </div>
                        <div class="text-primary xl:font-weight-bold invester-content">
                          {{ investment.pledgedAmount | numberSuffix }}
                        </div>
                      </div>
                      <div class="col-xl-2 investor-info date-order">
                        <div
                          class="text-uppercase xl:font-weight-bold font-size-smaller d-xl-none invester-title"
                        >
                          {{ 'portfolio.dateInvested' | translate }}
                        </div>
                        <div class="text-grey invester-content">
                          {{ investment.createdAt | amDateFormat: 'D MMM YYYY' }}
                        </div>
                      </div>
                      <div class="col-xl-2 investor-info type-order">
                        <div
                          class="text-uppercase xl:font-weight-bold font-size-smaller d-xl-none invester-title"
                        >
                          {{ 'portfolio.shareType' | translate }}
                        </div>
                        <div class="text-uppercase invester-content">
                          {{ ShareType[investment.shareType] | translate }}
                        </div>
                      </div>
                      <div class="col-xl-2 investor-info share-order">
                        <div
                          class="text-uppercase xl:font-weight-bold font-size-smaller d-xl-none invester-title"
                        >
                          {{ 'portfolio.totalSharedQuantity' | translate }}
                        </div>
                        <div class="text-grey invester-content">
                          {{ investment.shareQuantity | number }}
                        </div>
                      </div>
                      <div class="col-xl-2 investor-info status-order">
                        <div
                          class="text-uppercase xl:font-weight-bold font-size-smaller d-xl-none invester-title"
                        >
                          {{ 'common.status' | translate }}
                        </div>
                        <div
                          class="text-primary xl:font-weight-bold invester-content tw-text-xs"
                          [class.!tw-text-secondary]="investment.investmentStatus === 2"
                          [class.!tw-text-warning]="investment.investmentStatus === 6"
                        >
                          {{
                            'investment.' + InvestmentStatus[investment.investmentStatus]
                              | translate
                          }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div>
            @if (!isLoading && (!investments || investments.length == 0)) {
              <div class="pb-5 text-center">
                {{ 'common.noRecord' | translate }}
              </div>
            }
          </div>
          <div class="tw-inline-block tw-w-full">
            @if (total < params.take) {
              <div>
                <div class="paging tw-py-1.5 tw-text-sm">
                  {{ currentitem }} - {{ currentlastitem }} of {{ total }}
                </div>
              </div>
            }
            @if (total > params.take) {
              <div>
                <div class="paging mt-3">
                  <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-6">
                    <div class="tw-py-1.5 tw-text-sm">
                      {{ currentitem }} - {{ currentlastitem }} of {{ total }}
                    </div>
                    <ngb-pagination
                      [collectionSize]="total"
                      [(pageSize)]="params.take"
                      [(page)]="params.currentPage"
                      (pageChange)="filterByStatus(false)"
                      [maxSize]="3"
                      [rotate]="true"
                    >
                      <ng-template ngbPaginationPrevious
                        ><i class="fa fa-chevron-left"></i
                      ></ng-template>
                      <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
                      <ng-template ngbPaginationNext
                        ><i class="fa fa-chevron-right"></i
                      ></ng-template>
                    </ngb-pagination>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <app-empty-state
            [title]="'common.inviteOnlyEmptyStateTitle'"
            [message]="'common.inviteOnlyEmptyStateDescription'"
            [ctaUrl]="campaign?.registrationLinkUrl"
            [ctaText]="'common.registerInterest'"
          >
          </app-empty-state>
        }
      </div>
    </div>
  </div>
} @else {
  <agmo-loading></agmo-loading>
}
